define('presentation/settings/integrations/presentationObjects/integrationPresentationObject',[
    'i18next'
], function() {
    return function(){
        const self = this;

        const _i18n = require('i18next');

        self.platformId = null;
        self.name = null;
        self.description = null;
        self.iconCss = null;
        self.isConnected = ko.observable(false);
        self.isHoveringOver = ko.observable(false);
        self.oauthUrl = null;

        self.buttonText = ko.pureComputed(() => {
            if (self.isConnected() && self.isHoveringOver()) {
                return _i18n.t('integrations:remove');
            } else if (self.isConnected()) {
                return _i18n.t('integrations:connected');
            } else {
                return _i18n.t('integrations:connect');
            }
        });

        self.onMouseEnter = () => {
            self.isHoveringOver(true);
        };

        self.onMouseLeave = () => {
            self.isHoveringOver(false);
        };
    };
});

